import { useEffect } from "react";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import structuredData from "./structuredData.json";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Legacy from "./components/Legacy";
import Products from "./components/Products";
import Industries from "./components/Industries";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

function App() {
    useEffect(() => {
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.textContent = JSON.stringify(structuredData);
        document.head.appendChild(script);
        return () => document.head.removeChild(script);
    }, []);

    return (
        <ReactLenis root options={{ lerp: 0.09, duration: 1.35, anchors: true }}>
            <div className="bg-[#FAFAFA] text-[#111111] font-body min-h-screen">
                <div
                    aria-hidden="true"
                    className="grain-overlay fixed inset-0 z-[70] pointer-events-none opacity-[0.05]"
                />
                <Navbar />
                <main>
                    <Hero />
                    <Marquee />
                    <Legacy />
                    <Products />
                    <Industries />
                    <Contact />
                </main>
                <Footer />
                <WhatsAppButton />
                <Toaster
                    theme="light"
                    position="bottom-right"
                    toastOptions={{
                        style: {
                            background: "#F0F0F0",
                            border: "1px solid #D9D9D9",
                            borderRadius: 0,
                            color: "#111111",
                        },
                    }}
                />
            </div>
        </ReactLenis>
    );
}

export default App;
